export default{
  "Video Compressor": "Kompresor Video",
  "HitPaw Online Video Compressor": "Kompresor Video Online HitPaw",
  "Best video compressor tool to reduce video file size online without losing quality.": "Kompresor video terbaik untuk mengurangi ukuran file video secara online tanpa kehilangan kualitas.",
  "Quality": "Kualitas",
  "Small Size": "Ukuran Kecil ({{num}}%)",
  "High Quality": "Kualitas Tinggi ({{num}}%)",
  "Frame Rate": "Frame Rate",
  "Resolution": "Resolusi",
  "Keep Resolution": "Pertahankan Resolusi",
  "Format": "Format",
  "Compress": "Kompres",
  "Compressing": "Mengompresi",
  "Compress New": "Kompres Baru",
  "xx% reduction in size!": "{{num}}% pengurangan ukuran!",
  "Compressed successfully, your file is now xxMB.": "Berhasil dikompresi, file Anda sekarang <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>.",
  "Compression Failed": "Kompresi Gagal",
};